var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.$slots.header) ? _c(_vm.headerTag, {
    tag: "component",
    staticClass: "card-header",
    class: [_vm.headerClass]
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), (_vm.images && _vm.images.top) ? _c('img', {
    attrs: {
      "src": _vm.images.top.src,
      "alt": _vm.images.top.alt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.images && _vm.$slots.overlay) ? _c('div', {
    staticClass: "card-img-overlay"
  }, [_vm._t("overlay")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "card-body",
    class: [_vm.bodyClass]
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm._t("custom"), _vm._v(" "), (_vm.images && _vm.images.bottom) ? _c('img', {
    attrs: {
      "src": _vm.images.bottom.src,
      "alt": _vm.images.bottom.alt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "card-footer",
    class: [_vm.footerClass]
  }, [_vm._t("footer")], 2) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a49b92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/Card.vue
// module id = 133
// module chunks = 19